import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import apiClient from '@/api/axios';
import { CiteEditionBody } from './CiteCheckOutputActions';
import type { CiteEditionProjection } from '../../../../backend/src/services/dms/citeCheckPresentation';

export default function CiteCheckSharedEdition() {
  const { shareId } = useParams(), [query] = useSearchParams();
  const [view, setView] = useState<{ projection: CiteEditionProjection; note: string } | null>(null);
  const [error, setError] = useState(''), [pdf, setPdf] = useState<string | null>(null);
  useEffect(() => {
    let active = true, object: string | null = null;
    setView(null); setError(''); setPdf(null);
    const root = `/dms/documents/cite-check-shares/${encodeURIComponent(shareId || '')}`;
    void (async () => {
      try {
        const { data } = await apiClient.get<{ projection: CiteEditionProjection; note: string }>(root);
        if (!active) return; setView(data);
        const file = await apiClient.get(`${root}/files/pdf`, { responseType: 'blob' });
        if (active) { object = URL.createObjectURL(file.data); setPdf(object); }
      } catch { if (active) setError('This shared report is unavailable, access was revoked, or the file failed its integrity check.'); }
    })();
    return () => { active = false; if (object) URL.revokeObjectURL(object); };
  }, [shareId]);
  return <main className="mx-auto max-w-5xl p-4 text-[var(--lex-text-primary)]"><h1 className="text-xl font-semibold">Shared EdgeCite review</h1>
    {error ? <p role="alert">{error}</p> : !view ? <p role="status">Loading shared edition…</p> : <>
      {view.note && <p className="my-4 whitespace-pre-wrap">Message: {view.note}</p>}
      {pdf && <a className="my-4 inline-block underline" href={pdf} download="EdgeCite-review.pdf">Download exact PDF</a>}
      {query.get('file') === 'pdf' && pdf ? <iframe title="Shared citation review PDF" className="h-[80dvh] w-full" src={pdf} /> : <CiteEditionBody projection={view.projection} />}
    </>}
  </main>;
}
